import AtcFlightGroupDaysShiftArrival from './flight-group-days-shift-arrival-component';
import AtcFlightGroupDaysShiftArrivalService from './flight-group-days-shift-arrival-service';

const MODULE_NAME = 'app.atc.flight.segment.group.days-shift-arrival';
const module = angular.module(MODULE_NAME, [])
    .directive(AtcFlightGroupDaysShiftArrival.DIRECTIVE_NAME, AtcFlightGroupDaysShiftArrival)
    .service('atcFlightGroupDaysShiftArrivalService', AtcFlightGroupDaysShiftArrivalService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/atc/atc-flights-view/flight-recommendation/flight-segment/flight-group/flight-group-days-shift-arrival/flight-group-days-shift-arrival-module.js